// extracted by mini-css-extract-plugin
export default {"parentAlbum":"Album_parentAlbum__zxyZ-","albumHeader":"Album_albumHeader__uZ2oY","albumcarousel":"Album_albumcarousel__xjpVH","collap":"Album_collap__PtWbO"};